import { Navigate } from 'react-router-dom';
import WSA from '../../../WSA';
import { paths } from '../../paths';
import LoadingRoute from './LoadingRoute';

const GuestRoute = ({ redirect, children }) => {
  const { isAuthenticated } = WSA.Components.useWSAuth();

  return <LoadingRoute>{!isAuthenticated ? children : <Navigate to={redirect || paths.home} replace />}</LoadingRoute>;
};
export default GuestRoute;
